module.exports = __webpack_public_path__ + "img/softwcopr2.97dae85b.png";